<div class="demo-section k-content wide">
  <textarea id="app-rtf-editor-{{id}}" rows="10" cols="30" style="width:100%; height:840px" aria-label="editor"></textarea>
</div>
